export { type Word, wordTable } from "#word-table";
